import parse from "html-react-parser";

type ReviewItem = {
  author_name: string;
  tr_review_title: string;
  tr_review_text: string;
  rating_stars_icon: string;
  video_url?: string | null;
};

type ReviewsProps = {
  tr_heading: string;
  tr_subheading: string;
  reviews: ReviewItem[];
  verified_icon: string | null;
  tr_verified_label: string;
};

export const Reviews = ({
  tr_heading,
  tr_subheading,
  reviews,
  verified_icon,
  tr_verified_label,
}: ReviewsProps) => (
  <section className="reviews-section">
    <h2 className="reviews-title section-heading">{parse(tr_heading)}</h2>
    <div className="section-subtitle">{parse(tr_subheading)}</div>

    <div className="reviews-container">
      {reviews.map((review, idx) => (
        <div className="review-card" key={`${review.author_name}-${idx}`}>
          {review.video_url && (
            <div className="review-video-container">
              <video
                className="review-video"
                autoPlay
                muted
                loop
                playsInline
                aria-label={`Video testimonial from ${review.author_name}`}
              >
                <source src={review.video_url} type="video/mp4" />
              </video>
            </div>
          )}

          <div className="review-content">
            {review.rating_stars_icon && (
              <img
                src={review.rating_stars_icon}
                alt="Rating"
                className="review-stars-img"
              />
            )}
            {review.tr_review_title && (
              <h3 className="review-headline">{review.tr_review_title}</h3>
            )}
            <div className="review-text">{parse(review.tr_review_text)}</div>
          </div>

          <div className="review-author">
            <div className="author-info">
              <p className="author-name">{review.author_name}</p>
              {tr_verified_label && (
                <div className="verified-badge">
                  {verified_icon && <img src={verified_icon} alt="Verified" />}
                  <span>{tr_verified_label}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);
